import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const extractAd = async (url) => {
  const { data } = await axios.post(`${API}/extract`, { url });
  return data;
};

export const submitBugReport = async ({ name, email, description, screenshot }) => {
  const form = new FormData();
  form.append("name", name);
  form.append("email", email);
  form.append("description", description);
  if (screenshot) form.append("screenshot", screenshot);
  const { data } = await axios.post(`${API}/report-bug`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const buildProxyDownloadUrl = (url, filename) => {
  const params = new URLSearchParams({ url, filename });
  return `${API}/proxy?${params.toString()}`;
};
